/* tslint:disable */
/* eslint-disable */
/**
 * Legalscape REST API
 * Internal API for use from web
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateDeepResearchJobRequest } from '../model';
// @ts-ignore
import { EventsResponse } from '../model';
// @ts-ignore
import { GetLabsWandhAgreement200ResponseInner } from '../model';
// @ts-ignore
import { GetLabsWandhQuota200Response } from '../model';
// @ts-ignore
import { GetQuestionHistoryDetail200Response } from '../model';
// @ts-ignore
import { GetWandhAvailableBooks200Response } from '../model';
// @ts-ignore
import { HistoryShareResponse } from '../model';
// @ts-ignore
import { JobResponse } from '../model';
// @ts-ignore
import { ListQuestionHistories200Response } from '../model';
// @ts-ignore
import { PostLabsWandhEvaluationParamsBody } from '../model';
// @ts-ignore
import { PostLabsWandhQuestion200Response } from '../model';
// @ts-ignore
import { PostLabsWandhQuestionParamsBody } from '../model';
// @ts-ignore
import { PutLabsWandhDeepResearchPlanParamsBody } from '../model';
/**
 * LabsApi - axios parameter creator
 * @export
 */
export const LabsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 利用同意・権限の検証、クオータ予約を行ったうえで Deep Research Job を作成する。 
         * @summary Deep Research Job を作成
         * @param {CreateDeepResearchJobRequest} createDeepResearchJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeepResearchJob: async (createDeepResearchJobRequest: CreateDeepResearchJobRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDeepResearchJobRequest' is not null or undefined
            assertParamExists('createDeepResearchJob', 'createDeepResearchJobRequest', createDeepResearchJobRequest)
            const localVarPath = `/wandh/agents/deep-research`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDeepResearchJobRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 質問履歴の共有を作成する
         * @param {string} id 履歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHistoryShare: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createHistoryShare', 'id', id)
            const localVarPath = `/labs/wandh/question/histories/{id}/share`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 質問履歴の共有を無効化する
         * @param {string} id 履歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHistoryShare: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteHistoryShare', 'id', id)
            const localVarPath = `/labs/wandh/question/histories/{id}/share`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 質問履歴を論理削除する
         * @param {string} id 履歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuestionHistory: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteQuestionHistory', 'id', id)
            const localVarPath = `/labs/wandh/question/histories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Events を取得（ポーリング用）
         * @param {string} questionId 
         * @param {string} [after] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents: async (questionId: string, after?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('getEvents', 'questionId', questionId)
            const localVarPath = `/wandh/agents/deep-research/{questionId}/events`
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 質問履歴の共有情報を取得する
         * @param {string} id 履歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryShare: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getHistoryShare', 'id', id)
            const localVarPath = `/labs/wandh/question/histories/{id}/share`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 共有された質問履歴の詳細を取得する
         * @param {string} id 共有ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryShareDetail: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getHistoryShareDetail', 'id', id)
            const localVarPath = `/labs/wandh/share/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary question_id から Job を取得
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobByQuestionId: async (questionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('getJobByQuestionId', 'questionId', questionId)
            const localVarPath = `/wandh/agents/deep-research/{questionId}`
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 秘密保持誓約に同意した記録をデータベースから取得する
         * @summary 秘密保持誓約の同意記録を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabsWandhAgreement: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/labs/wandh/agreement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Watson & Holmesの残クオータを取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabsWandhQuota: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/labs/wandh/quota`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 質問履歴一覧を取得する
         * @param {string} id 履歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionHistoryDetail: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getQuestionHistoryDetail', 'id', id)
            const localVarPath = `/labs/wandh/question/histories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary W&Hで利用可能な書籍一覧を取得する
         * @param {string} [keyword] 書籍タイトルの部分一致検索キーワード（store/other共通）
         * @param {number} [storeOffset] store（購入書籍）の取得開始位置
         * @param {number} [storeLimit] store（購入書籍）の取得件数上限。省略時は全件返却
         * @param {number} [otherOffset] other（その他の書籍）の取得開始位置
         * @param {number} [otherLimit] other（その他の書籍）の取得件数上限。省略時は全件返却
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWandhAvailableBooks: async (keyword?: string, storeOffset?: number, storeLimit?: number, otherOffset?: number, otherLimit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/wandh/available-books`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (storeOffset !== undefined) {
                localVarQueryParameter['storeOffset'] = storeOffset;
            }

            if (storeLimit !== undefined) {
                localVarQueryParameter['storeLimit'] = storeLimit;
            }

            if (otherOffset !== undefined) {
                localVarQueryParameter['otherOffset'] = otherOffset;
            }

            if (otherLimit !== undefined) {
                localVarQueryParameter['otherLimit'] = otherLimit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 質問履歴一覧を取得する
         * @param {number} [perPage] 1ページあたりの件数
         * @param {string} [after] このIDより古い（小さい）レコードを取得するためのカーソル
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuestionHistories: async (perPage?: number, after?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/labs/wandh/question/histories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (perPage !== undefined) {
                localVarQueryParameter['perPage'] = perPage;
            }

            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 秘密保持誓約に同意したことをデータベースに記録する
         * @summary 秘密保持誓約に同意する
         * @param {Array<string>} id 同意する項目のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLabsWandhAgreement: async (id: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postLabsWandhAgreement', 'id', id)
            const localVarPath = `/labs/wandh/agreement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id) {
                localVarQueryParameter['id'] = id.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Watson & Holmesの生成結果に評価を送信する。同一のセッションに複数回評価を送ってもよい（上書きされる）
         * @summary Watson & Holmesの生成結果に評価を送信する
         * @param {PostLabsWandhEvaluationParamsBody} [postLabsWandhEvaluationParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLabsWandhEvaluation: async (postLabsWandhEvaluationParamsBody?: PostLabsWandhEvaluationParamsBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/labs/wandh/evaluation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postLabsWandhEvaluationParamsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Watson & Holmesに自然言語で書かれた質問文を与え、処理を開始するために必要なトークンと接続先のホストを得る。 GAEではストリーミングができないため、ストリーミングを実現するためにはクライアントサイドから直接labs-wandhに通信する必要があり、その認証のための一時的なトークンを返す。 トークンは十分有効期限を短くするため、質問1回ごとにトークンを再取得させる。 
         * @summary Watson & Holmesに質問をリクエストする。
         * @param {PostLabsWandhQuestionParamsBody} [postLabsWandhQuestionParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLabsWandhQuestion: async (postLabsWandhQuestionParamsBody?: PostLabsWandhQuestionParamsBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/labs/wandh/question`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postLabsWandhQuestionParamsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deep Research 用のリサーチプランを更新し、Labs Wandh にフォワードする
         * @summary Deep Research のリサーチプランを更新する
         * @param {PutLabsWandhDeepResearchPlanParamsBody} [putLabsWandhDeepResearchPlanParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putLabsWandhDeepResearchPlan: async (putLabsWandhDeepResearchPlanParamsBody?: PutLabsWandhDeepResearchPlanParamsBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/wandh/agents/deep-research/plan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putLabsWandhDeepResearchPlanParamsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LabsApi - functional programming interface
 * @export
 */
export const LabsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LabsApiAxiosParamCreator(configuration)
    return {
        /**
         * 利用同意・権限の検証、クオータ予約を行ったうえで Deep Research Job を作成する。 
         * @summary Deep Research Job を作成
         * @param {CreateDeepResearchJobRequest} createDeepResearchJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDeepResearchJob(createDeepResearchJobRequest: CreateDeepResearchJobRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDeepResearchJob(createDeepResearchJobRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 質問履歴の共有を作成する
         * @param {string} id 履歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHistoryShare(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HistoryShareResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createHistoryShare(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 質問履歴の共有を無効化する
         * @param {string} id 履歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteHistoryShare(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteHistoryShare(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 質問履歴を論理削除する
         * @param {string} id 履歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteQuestionHistory(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteQuestionHistory(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Events を取得（ポーリング用）
         * @param {string} questionId 
         * @param {string} [after] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvents(questionId: string, after?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvents(questionId, after, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 質問履歴の共有情報を取得する
         * @param {string} id 履歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHistoryShare(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HistoryShareResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHistoryShare(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 共有された質問履歴の詳細を取得する
         * @param {string} id 共有ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHistoryShareDetail(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQuestionHistoryDetail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHistoryShareDetail(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary question_id から Job を取得
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobByQuestionId(questionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobByQuestionId(questionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 秘密保持誓約に同意した記録をデータベースから取得する
         * @summary 秘密保持誓約の同意記録を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLabsWandhAgreement(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetLabsWandhAgreement200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLabsWandhAgreement(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Watson & Holmesの残クオータを取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLabsWandhQuota(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLabsWandhQuota200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLabsWandhQuota(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 質問履歴一覧を取得する
         * @param {string} id 履歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionHistoryDetail(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQuestionHistoryDetail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionHistoryDetail(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary W&Hで利用可能な書籍一覧を取得する
         * @param {string} [keyword] 書籍タイトルの部分一致検索キーワード（store/other共通）
         * @param {number} [storeOffset] store（購入書籍）の取得開始位置
         * @param {number} [storeLimit] store（購入書籍）の取得件数上限。省略時は全件返却
         * @param {number} [otherOffset] other（その他の書籍）の取得開始位置
         * @param {number} [otherLimit] other（その他の書籍）の取得件数上限。省略時は全件返却
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWandhAvailableBooks(keyword?: string, storeOffset?: number, storeLimit?: number, otherOffset?: number, otherLimit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWandhAvailableBooks200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWandhAvailableBooks(keyword, storeOffset, storeLimit, otherOffset, otherLimit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 質問履歴一覧を取得する
         * @param {number} [perPage] 1ページあたりの件数
         * @param {string} [after] このIDより古い（小さい）レコードを取得するためのカーソル
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listQuestionHistories(perPage?: number, after?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListQuestionHistories200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listQuestionHistories(perPage, after, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 秘密保持誓約に同意したことをデータベースに記録する
         * @summary 秘密保持誓約に同意する
         * @param {Array<string>} id 同意する項目のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postLabsWandhAgreement(id: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postLabsWandhAgreement(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Watson & Holmesの生成結果に評価を送信する。同一のセッションに複数回評価を送ってもよい（上書きされる）
         * @summary Watson & Holmesの生成結果に評価を送信する
         * @param {PostLabsWandhEvaluationParamsBody} [postLabsWandhEvaluationParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postLabsWandhEvaluation(postLabsWandhEvaluationParamsBody?: PostLabsWandhEvaluationParamsBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postLabsWandhEvaluation(postLabsWandhEvaluationParamsBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Watson & Holmesに自然言語で書かれた質問文を与え、処理を開始するために必要なトークンと接続先のホストを得る。 GAEではストリーミングができないため、ストリーミングを実現するためにはクライアントサイドから直接labs-wandhに通信する必要があり、その認証のための一時的なトークンを返す。 トークンは十分有効期限を短くするため、質問1回ごとにトークンを再取得させる。 
         * @summary Watson & Holmesに質問をリクエストする。
         * @param {PostLabsWandhQuestionParamsBody} [postLabsWandhQuestionParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postLabsWandhQuestion(postLabsWandhQuestionParamsBody?: PostLabsWandhQuestionParamsBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostLabsWandhQuestion200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postLabsWandhQuestion(postLabsWandhQuestionParamsBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deep Research 用のリサーチプランを更新し、Labs Wandh にフォワードする
         * @summary Deep Research のリサーチプランを更新する
         * @param {PutLabsWandhDeepResearchPlanParamsBody} [putLabsWandhDeepResearchPlanParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putLabsWandhDeepResearchPlan(putLabsWandhDeepResearchPlanParamsBody?: PutLabsWandhDeepResearchPlanParamsBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putLabsWandhDeepResearchPlan(putLabsWandhDeepResearchPlanParamsBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LabsApi - factory interface
 * @export
 */
export const LabsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LabsApiFp(configuration)
    return {
        /**
         * 利用同意・権限の検証、クオータ予約を行ったうえで Deep Research Job を作成する。 
         * @summary Deep Research Job を作成
         * @param {CreateDeepResearchJobRequest} createDeepResearchJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeepResearchJob(createDeepResearchJobRequest: CreateDeepResearchJobRequest, options?: any): AxiosPromise<JobResponse> {
            return localVarFp.createDeepResearchJob(createDeepResearchJobRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 質問履歴の共有を作成する
         * @param {string} id 履歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHistoryShare(id: string, options?: any): AxiosPromise<HistoryShareResponse> {
            return localVarFp.createHistoryShare(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 質問履歴の共有を無効化する
         * @param {string} id 履歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHistoryShare(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteHistoryShare(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 質問履歴を論理削除する
         * @param {string} id 履歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuestionHistory(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteQuestionHistory(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Events を取得（ポーリング用）
         * @param {string} questionId 
         * @param {string} [after] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents(questionId: string, after?: string, options?: any): AxiosPromise<EventsResponse> {
            return localVarFp.getEvents(questionId, after, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 質問履歴の共有情報を取得する
         * @param {string} id 履歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryShare(id: string, options?: any): AxiosPromise<HistoryShareResponse> {
            return localVarFp.getHistoryShare(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 共有された質問履歴の詳細を取得する
         * @param {string} id 共有ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryShareDetail(id: string, options?: any): AxiosPromise<GetQuestionHistoryDetail200Response> {
            return localVarFp.getHistoryShareDetail(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary question_id から Job を取得
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobByQuestionId(questionId: string, options?: any): AxiosPromise<JobResponse> {
            return localVarFp.getJobByQuestionId(questionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 秘密保持誓約に同意した記録をデータベースから取得する
         * @summary 秘密保持誓約の同意記録を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabsWandhAgreement(options?: any): AxiosPromise<Array<GetLabsWandhAgreement200ResponseInner>> {
            return localVarFp.getLabsWandhAgreement(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Watson & Holmesの残クオータを取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabsWandhQuota(options?: any): AxiosPromise<GetLabsWandhQuota200Response> {
            return localVarFp.getLabsWandhQuota(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 質問履歴一覧を取得する
         * @param {string} id 履歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionHistoryDetail(id: string, options?: any): AxiosPromise<GetQuestionHistoryDetail200Response> {
            return localVarFp.getQuestionHistoryDetail(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary W&Hで利用可能な書籍一覧を取得する
         * @param {string} [keyword] 書籍タイトルの部分一致検索キーワード（store/other共通）
         * @param {number} [storeOffset] store（購入書籍）の取得開始位置
         * @param {number} [storeLimit] store（購入書籍）の取得件数上限。省略時は全件返却
         * @param {number} [otherOffset] other（その他の書籍）の取得開始位置
         * @param {number} [otherLimit] other（その他の書籍）の取得件数上限。省略時は全件返却
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWandhAvailableBooks(keyword?: string, storeOffset?: number, storeLimit?: number, otherOffset?: number, otherLimit?: number, options?: any): AxiosPromise<GetWandhAvailableBooks200Response> {
            return localVarFp.getWandhAvailableBooks(keyword, storeOffset, storeLimit, otherOffset, otherLimit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 質問履歴一覧を取得する
         * @param {number} [perPage] 1ページあたりの件数
         * @param {string} [after] このIDより古い（小さい）レコードを取得するためのカーソル
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuestionHistories(perPage?: number, after?: string, options?: any): AxiosPromise<ListQuestionHistories200Response> {
            return localVarFp.listQuestionHistories(perPage, after, options).then((request) => request(axios, basePath));
        },
        /**
         * 秘密保持誓約に同意したことをデータベースに記録する
         * @summary 秘密保持誓約に同意する
         * @param {Array<string>} id 同意する項目のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLabsWandhAgreement(id: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.postLabsWandhAgreement(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Watson & Holmesの生成結果に評価を送信する。同一のセッションに複数回評価を送ってもよい（上書きされる）
         * @summary Watson & Holmesの生成結果に評価を送信する
         * @param {PostLabsWandhEvaluationParamsBody} [postLabsWandhEvaluationParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLabsWandhEvaluation(postLabsWandhEvaluationParamsBody?: PostLabsWandhEvaluationParamsBody, options?: any): AxiosPromise<void> {
            return localVarFp.postLabsWandhEvaluation(postLabsWandhEvaluationParamsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Watson & Holmesに自然言語で書かれた質問文を与え、処理を開始するために必要なトークンと接続先のホストを得る。 GAEではストリーミングができないため、ストリーミングを実現するためにはクライアントサイドから直接labs-wandhに通信する必要があり、その認証のための一時的なトークンを返す。 トークンは十分有効期限を短くするため、質問1回ごとにトークンを再取得させる。 
         * @summary Watson & Holmesに質問をリクエストする。
         * @param {PostLabsWandhQuestionParamsBody} [postLabsWandhQuestionParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLabsWandhQuestion(postLabsWandhQuestionParamsBody?: PostLabsWandhQuestionParamsBody, options?: any): AxiosPromise<PostLabsWandhQuestion200Response> {
            return localVarFp.postLabsWandhQuestion(postLabsWandhQuestionParamsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Deep Research 用のリサーチプランを更新し、Labs Wandh にフォワードする
         * @summary Deep Research のリサーチプランを更新する
         * @param {PutLabsWandhDeepResearchPlanParamsBody} [putLabsWandhDeepResearchPlanParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putLabsWandhDeepResearchPlan(putLabsWandhDeepResearchPlanParamsBody?: PutLabsWandhDeepResearchPlanParamsBody, options?: any): AxiosPromise<void> {
            return localVarFp.putLabsWandhDeepResearchPlan(putLabsWandhDeepResearchPlanParamsBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LabsApi - interface
 * @export
 * @interface LabsApi
 */
export interface LabsApiInterface {
    /**
     * 利用同意・権限の検証、クオータ予約を行ったうえで Deep Research Job を作成する。 
     * @summary Deep Research Job を作成
     * @param {CreateDeepResearchJobRequest} createDeepResearchJobRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApiInterface
     */
    createDeepResearchJob(createDeepResearchJobRequest: CreateDeepResearchJobRequest, options?: AxiosRequestConfig): AxiosPromise<JobResponse>;

    /**
     * 
     * @summary 質問履歴の共有を作成する
     * @param {string} id 履歴ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApiInterface
     */
    createHistoryShare(id: string, options?: AxiosRequestConfig): AxiosPromise<HistoryShareResponse>;

    /**
     * 
     * @summary 質問履歴の共有を無効化する
     * @param {string} id 履歴ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApiInterface
     */
    deleteHistoryShare(id: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary 質問履歴を論理削除する
     * @param {string} id 履歴ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApiInterface
     */
    deleteQuestionHistory(id: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Events を取得（ポーリング用）
     * @param {string} questionId 
     * @param {string} [after] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApiInterface
     */
    getEvents(questionId: string, after?: string, options?: AxiosRequestConfig): AxiosPromise<EventsResponse>;

    /**
     * 
     * @summary 質問履歴の共有情報を取得する
     * @param {string} id 履歴ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApiInterface
     */
    getHistoryShare(id: string, options?: AxiosRequestConfig): AxiosPromise<HistoryShareResponse>;

    /**
     * 
     * @summary 共有された質問履歴の詳細を取得する
     * @param {string} id 共有ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApiInterface
     */
    getHistoryShareDetail(id: string, options?: AxiosRequestConfig): AxiosPromise<GetQuestionHistoryDetail200Response>;

    /**
     * 
     * @summary question_id から Job を取得
     * @param {string} questionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApiInterface
     */
    getJobByQuestionId(questionId: string, options?: AxiosRequestConfig): AxiosPromise<JobResponse>;

    /**
     * 秘密保持誓約に同意した記録をデータベースから取得する
     * @summary 秘密保持誓約の同意記録を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApiInterface
     */
    getLabsWandhAgreement(options?: AxiosRequestConfig): AxiosPromise<Array<GetLabsWandhAgreement200ResponseInner>>;

    /**
     * 
     * @summary Watson & Holmesの残クオータを取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApiInterface
     */
    getLabsWandhQuota(options?: AxiosRequestConfig): AxiosPromise<GetLabsWandhQuota200Response>;

    /**
     * 
     * @summary 質問履歴一覧を取得する
     * @param {string} id 履歴ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApiInterface
     */
    getQuestionHistoryDetail(id: string, options?: AxiosRequestConfig): AxiosPromise<GetQuestionHistoryDetail200Response>;

    /**
     * 
     * @summary W&Hで利用可能な書籍一覧を取得する
     * @param {string} [keyword] 書籍タイトルの部分一致検索キーワード（store/other共通）
     * @param {number} [storeOffset] store（購入書籍）の取得開始位置
     * @param {number} [storeLimit] store（購入書籍）の取得件数上限。省略時は全件返却
     * @param {number} [otherOffset] other（その他の書籍）の取得開始位置
     * @param {number} [otherLimit] other（その他の書籍）の取得件数上限。省略時は全件返却
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApiInterface
     */
    getWandhAvailableBooks(keyword?: string, storeOffset?: number, storeLimit?: number, otherOffset?: number, otherLimit?: number, options?: AxiosRequestConfig): AxiosPromise<GetWandhAvailableBooks200Response>;

    /**
     * 
     * @summary 質問履歴一覧を取得する
     * @param {number} [perPage] 1ページあたりの件数
     * @param {string} [after] このIDより古い（小さい）レコードを取得するためのカーソル
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApiInterface
     */
    listQuestionHistories(perPage?: number, after?: string, options?: AxiosRequestConfig): AxiosPromise<ListQuestionHistories200Response>;

    /**
     * 秘密保持誓約に同意したことをデータベースに記録する
     * @summary 秘密保持誓約に同意する
     * @param {Array<string>} id 同意する項目のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApiInterface
     */
    postLabsWandhAgreement(id: Array<string>, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Watson & Holmesの生成結果に評価を送信する。同一のセッションに複数回評価を送ってもよい（上書きされる）
     * @summary Watson & Holmesの生成結果に評価を送信する
     * @param {PostLabsWandhEvaluationParamsBody} [postLabsWandhEvaluationParamsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApiInterface
     */
    postLabsWandhEvaluation(postLabsWandhEvaluationParamsBody?: PostLabsWandhEvaluationParamsBody, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Watson & Holmesに自然言語で書かれた質問文を与え、処理を開始するために必要なトークンと接続先のホストを得る。 GAEではストリーミングができないため、ストリーミングを実現するためにはクライアントサイドから直接labs-wandhに通信する必要があり、その認証のための一時的なトークンを返す。 トークンは十分有効期限を短くするため、質問1回ごとにトークンを再取得させる。 
     * @summary Watson & Holmesに質問をリクエストする。
     * @param {PostLabsWandhQuestionParamsBody} [postLabsWandhQuestionParamsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApiInterface
     */
    postLabsWandhQuestion(postLabsWandhQuestionParamsBody?: PostLabsWandhQuestionParamsBody, options?: AxiosRequestConfig): AxiosPromise<PostLabsWandhQuestion200Response>;

    /**
     * Deep Research 用のリサーチプランを更新し、Labs Wandh にフォワードする
     * @summary Deep Research のリサーチプランを更新する
     * @param {PutLabsWandhDeepResearchPlanParamsBody} [putLabsWandhDeepResearchPlanParamsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApiInterface
     */
    putLabsWandhDeepResearchPlan(putLabsWandhDeepResearchPlanParamsBody?: PutLabsWandhDeepResearchPlanParamsBody, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * LabsApi - object-oriented interface
 * @export
 * @class LabsApi
 * @extends {BaseAPI}
 */
export class LabsApi extends BaseAPI implements LabsApiInterface {
    /**
     * 利用同意・権限の検証、クオータ予約を行ったうえで Deep Research Job を作成する。 
     * @summary Deep Research Job を作成
     * @param {CreateDeepResearchJobRequest} createDeepResearchJobRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApi
     */
    public createDeepResearchJob(createDeepResearchJobRequest: CreateDeepResearchJobRequest, options?: AxiosRequestConfig) {
        return LabsApiFp(this.configuration).createDeepResearchJob(createDeepResearchJobRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 質問履歴の共有を作成する
     * @param {string} id 履歴ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApi
     */
    public createHistoryShare(id: string, options?: AxiosRequestConfig) {
        return LabsApiFp(this.configuration).createHistoryShare(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 質問履歴の共有を無効化する
     * @param {string} id 履歴ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApi
     */
    public deleteHistoryShare(id: string, options?: AxiosRequestConfig) {
        return LabsApiFp(this.configuration).deleteHistoryShare(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 質問履歴を論理削除する
     * @param {string} id 履歴ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApi
     */
    public deleteQuestionHistory(id: string, options?: AxiosRequestConfig) {
        return LabsApiFp(this.configuration).deleteQuestionHistory(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Events を取得（ポーリング用）
     * @param {string} questionId 
     * @param {string} [after] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApi
     */
    public getEvents(questionId: string, after?: string, options?: AxiosRequestConfig) {
        return LabsApiFp(this.configuration).getEvents(questionId, after, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 質問履歴の共有情報を取得する
     * @param {string} id 履歴ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApi
     */
    public getHistoryShare(id: string, options?: AxiosRequestConfig) {
        return LabsApiFp(this.configuration).getHistoryShare(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 共有された質問履歴の詳細を取得する
     * @param {string} id 共有ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApi
     */
    public getHistoryShareDetail(id: string, options?: AxiosRequestConfig) {
        return LabsApiFp(this.configuration).getHistoryShareDetail(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary question_id から Job を取得
     * @param {string} questionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApi
     */
    public getJobByQuestionId(questionId: string, options?: AxiosRequestConfig) {
        return LabsApiFp(this.configuration).getJobByQuestionId(questionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 秘密保持誓約に同意した記録をデータベースから取得する
     * @summary 秘密保持誓約の同意記録を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApi
     */
    public getLabsWandhAgreement(options?: AxiosRequestConfig) {
        return LabsApiFp(this.configuration).getLabsWandhAgreement(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Watson & Holmesの残クオータを取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApi
     */
    public getLabsWandhQuota(options?: AxiosRequestConfig) {
        return LabsApiFp(this.configuration).getLabsWandhQuota(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 質問履歴一覧を取得する
     * @param {string} id 履歴ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApi
     */
    public getQuestionHistoryDetail(id: string, options?: AxiosRequestConfig) {
        return LabsApiFp(this.configuration).getQuestionHistoryDetail(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary W&Hで利用可能な書籍一覧を取得する
     * @param {string} [keyword] 書籍タイトルの部分一致検索キーワード（store/other共通）
     * @param {number} [storeOffset] store（購入書籍）の取得開始位置
     * @param {number} [storeLimit] store（購入書籍）の取得件数上限。省略時は全件返却
     * @param {number} [otherOffset] other（その他の書籍）の取得開始位置
     * @param {number} [otherLimit] other（その他の書籍）の取得件数上限。省略時は全件返却
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApi
     */
    public getWandhAvailableBooks(keyword?: string, storeOffset?: number, storeLimit?: number, otherOffset?: number, otherLimit?: number, options?: AxiosRequestConfig) {
        return LabsApiFp(this.configuration).getWandhAvailableBooks(keyword, storeOffset, storeLimit, otherOffset, otherLimit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 質問履歴一覧を取得する
     * @param {number} [perPage] 1ページあたりの件数
     * @param {string} [after] このIDより古い（小さい）レコードを取得するためのカーソル
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApi
     */
    public listQuestionHistories(perPage?: number, after?: string, options?: AxiosRequestConfig) {
        return LabsApiFp(this.configuration).listQuestionHistories(perPage, after, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 秘密保持誓約に同意したことをデータベースに記録する
     * @summary 秘密保持誓約に同意する
     * @param {Array<string>} id 同意する項目のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApi
     */
    public postLabsWandhAgreement(id: Array<string>, options?: AxiosRequestConfig) {
        return LabsApiFp(this.configuration).postLabsWandhAgreement(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Watson & Holmesの生成結果に評価を送信する。同一のセッションに複数回評価を送ってもよい（上書きされる）
     * @summary Watson & Holmesの生成結果に評価を送信する
     * @param {PostLabsWandhEvaluationParamsBody} [postLabsWandhEvaluationParamsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApi
     */
    public postLabsWandhEvaluation(postLabsWandhEvaluationParamsBody?: PostLabsWandhEvaluationParamsBody, options?: AxiosRequestConfig) {
        return LabsApiFp(this.configuration).postLabsWandhEvaluation(postLabsWandhEvaluationParamsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Watson & Holmesに自然言語で書かれた質問文を与え、処理を開始するために必要なトークンと接続先のホストを得る。 GAEではストリーミングができないため、ストリーミングを実現するためにはクライアントサイドから直接labs-wandhに通信する必要があり、その認証のための一時的なトークンを返す。 トークンは十分有効期限を短くするため、質問1回ごとにトークンを再取得させる。 
     * @summary Watson & Holmesに質問をリクエストする。
     * @param {PostLabsWandhQuestionParamsBody} [postLabsWandhQuestionParamsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApi
     */
    public postLabsWandhQuestion(postLabsWandhQuestionParamsBody?: PostLabsWandhQuestionParamsBody, options?: AxiosRequestConfig) {
        return LabsApiFp(this.configuration).postLabsWandhQuestion(postLabsWandhQuestionParamsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deep Research 用のリサーチプランを更新し、Labs Wandh にフォワードする
     * @summary Deep Research のリサーチプランを更新する
     * @param {PutLabsWandhDeepResearchPlanParamsBody} [putLabsWandhDeepResearchPlanParamsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabsApi
     */
    public putLabsWandhDeepResearchPlan(putLabsWandhDeepResearchPlanParamsBody?: PutLabsWandhDeepResearchPlanParamsBody, options?: AxiosRequestConfig) {
        return LabsApiFp(this.configuration).putLabsWandhDeepResearchPlan(putLabsWandhDeepResearchPlanParamsBody, options).then((request) => request(this.axios, this.basePath));
    }
}
